'use client'

import { Check, ChevronsUpDown } from 'lucide-react'
import * as React from 'react'

import { Button } from '#app/components/ui/button'
import {
	Command,
	CommandEmpty,
	CommandGroup,
	CommandInput,
	CommandItem,
	CommandList,
} from '#app/components/ui/command'
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '#app/components/ui/popover'
import { cn } from '#app/utils/misc'

export function Combobox({
	options,
	value,
	setValue,
	placeholder,
	inputProps,
	emptyMessage,
}: {
	options: { value: string; label: React.ReactNode }[]
	value?: string
	setValue?: React.Dispatch<React.SetStateAction<any>>
	placeholder?: string
	inputProps?: React.InputHTMLAttributes<HTMLInputElement>
	emptyMessage?: string
}) {
	const [open, setOpen] = React.useState(false)

	const onChange = inputProps?.onChange

	return (
		<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger asChild>
				<Button
					variant="outline"
					type="button"
					role="combobox"
					aria-expanded={open}
					className="w-[200px] justify-between"
				>
					{value
						? options.find((option) => option.value === value)?.label
						: placeholder}
					<ChevronsUpDown className="opacity-50" />
				</Button>
			</PopoverTrigger>
			<PopoverContent className="w-[200px] p-0">
				<Command>
					<CommandInput placeholder={placeholder} />
					<CommandList>
						<CommandEmpty>{emptyMessage ?? 'No options found.'}</CommandEmpty>
						<CommandGroup>
							{options.map((option) => (
								<CommandItem
									key={option.value}
									value={option.value}
									onSelect={(currentValue) => {
										setValue
											? setValue(currentValue === value ? '' : currentValue)
											: null
										setOpen(false)
										onChange?.({
											target: {
												value: currentValue,
											},
										} as React.ChangeEvent<HTMLInputElement>)
									}}
								>
									{option.label}
									<Check
										className={cn(
											'ml-auto',
											value === option.value ? 'opacity-100' : 'opacity-0',
										)}
									/>
								</CommandItem>
							))}
						</CommandGroup>
					</CommandList>
				</Command>
			</PopoverContent>
		</Popover>
	)
}
